import { TrialHeaderQueryHookResult, useUpdatePersonalTrialMutation } from "@generated/graphql";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { parseApolloError } from "helpers/errorsParser";
import { getTestingPath } from "helpers/index";
import useIsCreate from "hooks/useIsCreate";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UpdateTrialParams } from "../types";

interface UseUpdateTrialProps {
  refetchTrialHeader: TrialHeaderQueryHookResult["refetch"];
}

const useUpdateTrial = ({ refetchTrialHeader }: UseUpdateTrialProps) => {
  const navigate = useNavigate();
  const { addToast } = useContext(ToastContext);
  const isCreate = useIsCreate();

  const toggleToastOnSuccess = (text?: string) => addToast({ type: ToastTypeEnum.SUCCESS, text });
  const navigateToCreatedTesting = (id: string) => navigate(getTestingPath("trial", id));

  const [updateTrial, { loading: updateTrialLoading }] = useUpdatePersonalTrialMutation();

  const onUpdateTrial = ({ formData, candidateId, setIsEditing }: UpdateTrialParams) => {
    updateTrial({
      variables: {
        input: {
          id: formData.id,
          title: formData.title,
          competencyMapId: formData.competencyMap?.id,
          comment: formData.comment,
          companyCandidateId: candidateId,
        },
      },
    })
      .then((res) => {
        const createdId = res.data?.updatePersonalTrial.id;
        if (isCreate && createdId) {
          navigateToCreatedTesting(createdId);
        } else {
          setIsEditing(false);
          toggleToastOnSuccess();
          refetchTrialHeader();
        }
      })
      .catch((e) => parseApolloError(e, { addToast }));
  };

  return { updateTrialLoading, onUpdateTrial };
};

export default useUpdateTrial;
